import { hexToRgba } from "~/utils/style";

import { SHADES_GRADE } from "./createPalette";
import { ShadesGrade } from "./declarations";

export const generateShadesPalette = (baseColor: string): ShadesGrade =>
  Object.fromEntries(
    SHADES_GRADE.map(item => [item, hexToRgba(baseColor, item / 100)])
  ) as ShadesGrade;
